// module.exports=file=>()=>import('../.'+file)
const fun=function (file) {
    // console.log(file);
    // console.log(file.substring(0,11));
    // if(file.substring(0,11) == '/components'){
    // 	console.log('ppppppppp')
    // }
    return require(`../../views${file}`)
    
    
}

exports.function1=fun
